/**
 * TryAnotherAccount — chooser embedded inside the not-found screen when the
 * current tab is signed into multiple accounts.
 */

import { For, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";
import { useAccounts } from "./use-accounts";

export function TryAnotherAccount() {
  const { t } = useI18n();
  const { accounts, activeUserId, switchHere } = useAccounts();

  const otherAccounts = () => accounts().filter((a) => a.userId !== activeUserId());

  return (
    <Show when={otherAccounts().length > 0}>
      <div data-testid="try-another-account" class="mt-4 flex flex-col items-center gap-2 text-sm">
        <p class="text-muted-foreground">
          {t(msg`Signed in with more than one account? Try another one:`)}
        </p>
        <div class="flex flex-wrap justify-center gap-2">
          <For each={otherAccounts()}>
            {(account) => (
              <button
                type="button"
                data-testid={`try-account-${account.userId}`}
                class="inline-flex items-center gap-1.5 rounded-md border border-input bg-background px-3 py-1 text-xs font-medium hover:bg-accent hover:text-accent-foreground"
                onClick={() => {
                  void switchHere(account.userId);
                }}
              >
                <span>{account.displayName}</span>
              </button>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}
